import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from '@gs1france/gs1-components-library';

@Component({
    selector: 'browser-warning-modal',
    styleUrls: ['./browser-warning-modal.less'],
    templateUrl: './browser-warning-modal.component.html'
})
export class BrowserWarningModalComponent implements OnInit, AfterViewInit {
    @ViewChild('directiveRef', { static: false }) public browserWarningModal: ModalDirective;
    @Output() public modalProcessedEvent = new EventEmitter<boolean>();
    public customHtml = '';
    public isSafari = false;
    public isSmallScreen = false;
    public readonly CONFIRM_BT_TXT = "Ok, j'ai compris";
    public readonly SMALL_SCREEN_WIDTH = 768;
    public readonly STORAGE_KEY = 'browserWarningModalDismissed';
    public readonly SAFRI_HTML_MSG = `<div>Nous avons remarqué que vous utilisez Safari. Certaines fonctionnalités pourraient ne pas fonctionner de manière optimale avec ce navigateur. Pour une navigation plus fluide, nous vous conseillons d’utiliser Chrome ou Firefox.</div>`;
    public readonly SMALL_SCREEN_HTML_MSG = `<div>Notre plateforme est conçue pour être utilisée sur un ordinateur afin de vous offrir la meilleure expérience possible. Pour profiter pleinement de toutes les fonctionnalités, nous vous recommandons d'utiliser un écran plus grand.</div>`;

    constructor() { }

    public openModal() {
        this.browserWarningModal.openDialog();
    }

    public ngOnInit(): void {
        this.isSafari = this.checkSafari();
        this.isSmallScreen = this.checkSmallScreen();
        if (this.shouldShowWarning()) {
            this.setCustomHtml();
        }
    }

    public ngAfterViewInit() {
        if (this.shouldShowWarning()) {
            this.openModal();
        } else {
            // Considered processed eventhough the result is not to open the modal.
            this.modalProcessedEvent.emit(true);
        }
    }


    public validateWarning(accepted: boolean) {
        if (accepted) {
            localStorage.setItem(this.STORAGE_KEY, 'true');
        }
        // Considered processed since it is called only when the modal is closed in both cases by ok or x.
        this.modalProcessedEvent.emit(true);
    }

    public shouldShowWarning(): boolean {
        return (this.isSafari || this.isSmallScreen) && !localStorage.getItem(this.STORAGE_KEY);
    }

    private checkSafari(): boolean {
        const ua = navigator.userAgent;
        // Detect Safari (desktop or tablet or mobile), but not Chrome Or Firefox or other Chromium-based browsers like Edge, Opera, Brave etc.
        return /safari/i.test(ua) && !/chrome|crios|android|fxios|edg|opr|brave/i.test(ua);
    }
    private checkSmallScreen(): boolean {
        return window.innerWidth <= this.SMALL_SCREEN_WIDTH;
    }

    private setCustomHtml() {
        if (this.isSafari && this.isSmallScreen) {
            this.customHtml = this.SAFRI_HTML_MSG + `<hr style='margin:16px 0;'>` + this.SMALL_SCREEN_HTML_MSG;
        } else if (this.isSafari) {
            this.customHtml = this.SAFRI_HTML_MSG;
        } else if (this.isSmallScreen) {
            this.customHtml = this.SMALL_SCREEN_HTML_MSG;
        }
    }
}
